const { initPerfume } = require('perfume.js');
const { RESOURCE_TIMING } = require('../../constants/metrics');
const { metricSupport } = require('../../constants/resource-timing');
const { appendMetric } = require('../collector');
const { truncateDecimals } = require('../utils/number');

module.exports = () => initPerfume({
  resourceTiming: true,
  analyticsTracker: ({ metricName, data }) => {
    /* istanbul ignore next */
    if (metricName === RESOURCE_TIMING && metricSupport.includes(data.initiatorType)) {
      const metric = JSON.parse(JSON.stringify(data)); // because data is a class and i need to iterate its properties
      Object.keys(metric).forEach((key) => {
        if (typeof metric[key] === 'number') {
          metric[key] = truncateDecimals(metric[key]);
        }
      });

      appendMetric(RESOURCE_TIMING, metric);
    }
  },
});
